import { render, staticRenderFns } from "./manageMetric.vue?vue&type=template&id=07597be6"
import script from "./manageMetric.vue?vue&type=script&lang=js"
export * from "./manageMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports